/** @jsxImportSource @emotion/react */
import { HomeLayout } from './HomeLayout'
import { Referral } from '../../components/Home/Referral'

export const HomeReferral = () => {
  return (
    <HomeLayout>
      <Referral />
    </HomeLayout>
  )
}
